// Generic Device Type Templates

import { Template01_Auto } from './Template01_Auto';

export { Template01_Auto } from './Template01_Auto';

// Template registry for dynamic selection
export const GenericTemplates = {
  Template01: () => import('./Template01_Auto').then(m => m.Template01_Auto),
} as const;

// Default export
export default Template01_Auto;
